// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Eye Icon */
.eye {
  color: grey;
}

/* Send OTP Button */
.sendotp {
  border: none;
  background-color: transparent;
  color: #dbdbdb;
  /* Default color before OTP is sent */
  cursor: pointer;
}

input:-webkit-autofill {
  background-color: transparent !important;
  /* Transparent by default */
  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
  /* Transparent shadow */
  color: #333 !important;
  /* Text color */
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
  /* Smooth transition */
}

/* White Background on Focus and After */
input:-webkit-autofill:focus,
input:-webkit-autofill:not(:placeholder-shown) {
  background-color: #e7e7e7 !important;
  /* Stay white when focused or filled */
  -webkit-box-shadow: 0 0 0 1000px #e7e7e7 inset !important;
  /* Consistent white background */
  color: #333 !important;
  /* Text color */
  outline: none !important;
  /* Remove outline */
}

/* Sign Up Title */
.signup-title {
  text-align: center;
  margin-right: 25%;
  padding-right: 6%;
  margin-bottom: 20px;
  font-size: 1.3rem;
  color: #333;
}

/* Form Container */
.card-container {
  margin-left: 8%;
  margin-right: 8%;
  background-color: #f4f5f7;
  border: none;
  box-shadow: none;
  padding: 20px;
}

/* Row and Column Containers */
.row-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f5f7;
  flex-wrap: wrap;
}

.column-container {
  max-width: 400px;
  width: 80%;
  background-color: #f4f5f7;
}

/* Input Containers */
.input-containers {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
  color: #000;
  background-color: #f5f5f5;
  /* Consistent light background */
  border-radius: 4px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

/* OTP Link */
.input-containers .otp-link1 {
  right: 12px;
  color: #9e9e9e;
  font-size: 12px;
  text-decoration: none;
  border-radius: 4px;
}

/* Alert Messages */
.alert1 {
  font-size: 14px;
  color: #f44336;
  margin-top: 5px;
}

/* Password Validation Section */
.ul1 {
  list-style: none;
  padding: 0;
  margin: 8px 0;
}

.ul1 li {
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  color: #555;
}

.ul1 li svg {
  margin-right: 8px;
  font-size: 22px;
  width: 18px;
  height: 18px;
}

.ul1 li.success svg {
  color: #4caf50;
}

.ul1 li.error svg {
  color: #f44336;
}

/* Button Styling */
.create-button {
  padding: 10px 20px;
  background-color: #357ab7;
  color: #fff;
  border-radius: 4px;
  border: none;
}

.create-button:hover {
  background-color: #357ab7;
}

/* Responsive Design */
@media (max-width: 600px) {
  form {
    padding: 20px;
  }

  h3 {
    font-size: 20px;
  }

  .input-containers input {
    padding-right: 35px;
  }

  .container {
    width: 100%;
    /* Ensure full width on small screens */
  }
}
/* Header Styling */
.header2 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* Logo Styling */
.logo {
  width: 150px;
  height: auto;
  object-fit: contain;
}

/* Footer Styling */
.footer3 {
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
  text-align: right;
  font-size: 14px;
  color: #000000;
  padding: 10px 20px;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin: 0;
}

/* Link Styling */
.login-link {
  color: black;
  text-decoration: underline;
  font-weight: bold;
}

.signup-footer-bar {
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
  text-align: right;
  font-size: 14px;
  color: #000000;
  padding: 10px;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin: 0;
}

.signup-navigation-bar {
  display: flex;
  justify-content: left;
  align-items: left;
  padding: 10px 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: 0px;
}

.signup-container {
  background-color: #fff;
  display: flex;
  justify-content: center;
  margin: 0;
  height: 100%;
  padding-bottom: 12px;
}

.signup-form-control {
  background-color: transparent;
  padding: 0;
  border: none;
  margin-top: 5px;
}

.signup-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  background-color: #0a65cc;
  color: #fff;
  border-radius: 8px;
  width: 100%;
  padding: 10px;
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./../portfolio/src/pages/CandidateUserSignUp/CandidateUserSignUp.scss"],"names":[],"mappings":"AAAA,aAAA;AACA;EACE,WAAA;AACF;;AAEA,oBAAA;AACA;EACE,YAAA;EACA,6BAAA;EACA,cAAA;EAAgB,qCAAA;EAChB,eAAA;AAEF;;AAAA;EACE,wCAAA;EAA0C,2BAAA;EAC1C,6DAAA;EAA+D,uBAAA;EAC/D,sBAAA;EAAwB,eAAA;EACxB,8CAAA;EAAA,sCAAA;EAAwC,sBAAA;AAO1C;;AAJA,wCAAA;AACA;;EAEE,oCAAA;EAAsC,sCAAA;EACtC,yDAAA;EAA2D,gCAAA;EAC3D,sBAAA;EAAwB,eAAA;EACxB,wBAAA;EAA0B,mBAAA;AAW5B;;AATA,kBAAA;AACA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAYF;;AATA,mBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAYF;;AATA,8BAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAYF;;AATA;EACE,gBAAA;EACA,UAAA;EACA,yBAAA;AAYF;;AATA,qBAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EAA2B,gCAAA;EAC3B,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAaF;;AAVA,aAAA;AACA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AAaF;;AAVA,mBAAA;AACA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAaF;;AAVA,gCAAA;AACA;EACE,gBAAA;EACA,UAAA;EACA,aAAA;AAaF;;AAVA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAaF;;AAVA;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAaF;;AAVA;EACE,cAAA;AAaF;;AAVA;EACE,cAAA;AAaF;;AAVA,mBAAA;AACA;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AAaF;;AAVA;EACE,yBAAA;AAaF;;AAVA,sBAAA;AACA;EACE;IACE,aAAA;EAaF;;EAVA;IACE,eAAA;EAaF;;EAVA;IACE,mBAAA;EAaF;;EAVA;IACE,WAAA;IAAa,uCAAA;EAcf;AACF;AAXA,mBAAA;AACA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gCAAA;EACA,wCAAA;EACA,gBAAA;EACA,MAAA;EACA,aAAA;AAaF;;AAVA,iBAAA;AACA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAaF;;AAVA,mBAAA;AACA;EACE,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,aAAA;EACA,SAAA;AAaF;;AAVA,iBAAA;AACA;EACE,YAAA;EACA,0BAAA;EACA,iBAAA;AAaF;;AARA;EACE,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,yCAAA;EACA,aAAA;EACA,SAAA;AAWF;;AARA;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gCAAA;EACA,wCAAA;EACA,gBAAA;EACA,MAAA;EACA,aAAA;EACA,kBAAA;AAWF;;AARA;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;AAWF;;AARA;EACE,6BAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAWF;;AARA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EAEA,mBAAA;AASF","sourcesContent":["/* Eye Icon */\n.eye {\n  color: grey;\n}\n\n/* Send OTP Button */\n.sendotp {\n  border: none;\n  background-color: transparent;\n  color: #dbdbdb; /* Default color before OTP is sent */\n  cursor: pointer;\n}\ninput:-webkit-autofill {\n  background-color: transparent !important; /* Transparent by default */\n  -webkit-box-shadow: 0 0 0 1000px transparent inset !important; /* Transparent shadow */\n  color: #333 !important; /* Text color */\n  transition: background-color 0.3s ease; /* Smooth transition */\n}\n\n/* White Background on Focus and After */\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:not(:placeholder-shown) {\n  background-color: #e7e7e7 !important; /* Stay white when focused or filled */\n  -webkit-box-shadow: 0 0 0 1000px #e7e7e7 inset !important; /* Consistent white background */\n  color: #333 !important; /* Text color */\n  outline: none !important; /* Remove outline */\n}\n/* Sign Up Title */\n.signup-title {\n  text-align: center;\n  margin-right: 25%;\n  padding-right: 6%;\n  margin-bottom: 20px;\n  font-size: 1.3rem;\n  color: #333;\n}\n\n/* Form Container */\n.card-container {\n  margin-left: 8%;\n  margin-right: 8%;\n  background-color: #f4f5f7;\n  border: none;\n  box-shadow: none;\n  padding: 20px;\n}\n\n/* Row and Column Containers */\n.row-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f4f5f7;\n  flex-wrap: wrap;\n}\n\n.column-container {\n  max-width: 400px;\n  width: 80%;\n  background-color: #f4f5f7;\n}\n\n/* Input Containers */\n.input-containers {\n  position: relative;\n  width: 100%;\n  margin-bottom: 20px;\n  color: #000;\n  background-color: #f5f5f5; /* Consistent light background */\n  border-radius: 4px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n/* OTP Link */\n.input-containers .otp-link1 {\n  right: 12px;\n  color: #9e9e9e;\n  font-size: 12px;\n  text-decoration: none;\n  border-radius: 4px;\n}\n\n/* Alert Messages */\n.alert1 {\n  font-size: 14px;\n  color: #f44336;\n  margin-top: 5px;\n}\n\n/* Password Validation Section */\n.ul1 {\n  list-style: none;\n  padding: 0;\n  margin: 8px 0;\n}\n\n.ul1 li {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n  color: #555;\n}\n\n.ul1 li svg {\n  margin-right: 8px;\n  font-size: 22px;\n  width: 18px;\n  height: 18px;\n}\n\n.ul1 li.success svg {\n  color: #4caf50;\n}\n\n.ul1 li.error svg {\n  color: #f44336;\n}\n\n/* Button Styling */\n.create-button {\n  padding: 10px 20px;\n  background-color: #357ab7;\n  color: #fff;\n  border-radius: 4px;\n  border: none;\n}\n\n.create-button:hover {\n  background-color: #357ab7;\n}\n\n/* Responsive Design */\n@media (max-width: 600px) {\n  form {\n    padding: 20px;\n  }\n\n  h3 {\n    font-size: 20px;\n  }\n\n  .input-containers input {\n    padding-right: 35px;\n  }\n\n  .container {\n    width: 100%; /* Ensure full width on small screens */\n  }\n}\n\n/* Header Styling */\n.header2 {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 10px 20px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e0e0e0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n/* Logo Styling */\n.logo {\n  width: 150px;\n  height: auto;\n  object-fit: contain;\n}\n\n/* Footer Styling */\n.footer3 {\n  background-color: #ffffff;\n  border-top: 1px solid #e0e0e0;\n  text-align: right;\n  font-size: 14px;\n  color: #000000;\n  padding: 10px 20px;\n  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  margin: 0;\n}\n\n/* Link Styling */\n.login-link {\n  color: black;\n  text-decoration: underline;\n  font-weight: bold;\n}\n\n// Sabrina\n\n.signup-footer-bar {\n  background-color: #ffffff;\n  border-top: 1px solid #e0e0e0;\n  text-align: right;\n  font-size: 14px;\n  color: #000000;\n  padding: 10px;\n  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  margin: 0;\n}\n\n.signup-navigation-bar {\n  display: flex;\n  justify-content: left;\n  align-items: left;\n  padding: 10px 20px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e0e0e0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  margin-bottom: 0px;\n}\n\n.signup-container {\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  margin: 0;\n  height: 100%;\n  padding-bottom: 12px;\n}\n\n.signup-form-control {\n  background-color: transparent;\n  padding: 0;\n  border: none;\n  margin-top: 5px;\n}\n\n.signup-button {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n\n  background-color: #0a65cc;\n  color: #fff;\n  border-radius: 8px;\n  width: 100%;\n  padding: 10px;\n\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
